module.exports = __webpack_public_path__ + "static/fipcmonoanimal-0550f07212eca8cda73d0f3466947dc1.jpeg";